module.exports = __webpack_public_path__ + "static/2016-layer-2-9996b535ea832bd3d5843e4e4c2ae194.png";